(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('userTypeService', userTypeService);

    /* @ngInject */
    function userTypeService(coreService, $odataresource, config) {
        var service = {
            saveUserType: saveUserType,
            activateUserType: activateUserType,
            deactivateUserType: deactivateUserType,
            syncApplicationRoles: syncApplicationRoles,
            getUserTypeByUserId: getUserTypeByUserId,
            getUserTypeForLoggedInUser: getUserTypeForLoggedInUser,
            getDefaultApplications: getDefaultApplications,
            getUserTypeBasicFields: getUserTypeBasicFields,
            getUserTypeDisplayFields: getUserTypeDisplayFields,
            getUserTypeCreateFields: getUserTypeCreateFields,
            getUserTypes: getUserTypes,
            getODataResource: getODataResource,
            getTableConfig: getTableConfig,
            getModalOptions: getModalOptions,
            getDefaultUserType: getDefaultUserType
        };

        activate();

        return service;

        function activate() {
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/UserTypes',
                {},
                {},
                {
                    odatakey: 'UserTypeId',
                    isodatav4: true
                });
        }

        function saveUserType(userType) {
            return coreService.httpAccountsPost('user/type', userType);
        }

        function getDefaultApplications(userTypeId) {
            var url = 'user/' + encodeURIComponent(userTypeId) + '/defaultApplications';
            return coreService.httpAccountsGet(url);
        }

        function getUserTypeByUserId(userId) {
            var url = 'user/' + encodeURIComponent(userId) + '/type';
            return coreService.httpAccountsGet(url);
        }

        function activateUserType(userTypeId) {
            var url = 'user/type/' + encodeURIComponent(userTypeId) + '/activate';
            return coreService.httpAccountsPost(url);
        }

        function deactivateUserType(userTypeId) {
            var url = 'user/type/' + encodeURIComponent(userTypeId) + '/deactivate';
            return coreService.httpAccountsPost(url);
        }

        function syncApplicationRoles(userTypeId) {
            var url = 'user/type/' + encodeURIComponent(userTypeId) + '/sync';
            return coreService.httpAccountsPost(url);
        }

        function getUserTypeForLoggedInUser() {
            var url = 'user/type/loggedInUser';
            return coreService.httpAccountsGet(url);
        }

        function getUserTypeBasicFields(userCategoryId, userCategories, onValidate) {
            var fields = [
                {
                    key: 'UserTypeName',
                    type: 'input',
                    templateOptions: {
                        type: 'text',
                        label: 'User Type Name',
                        placeholder: 'Enter the User Type Name',
                        required: true,
                        maxlength: 100,
                        onChange: function (a, b, events) {
                            onValidate(events.fc.$valid);
                        }
                    }
                }, {
                    key: 'UserCategoryId',
                    type: 'ui-select-single',
                    defaultValue: userCategoryId,
                    templateOptions: {
                        options: userCategories,
                        disabled: false,
                        optionsAttr: 'bs-options',
                        label: 'User Category',
                        ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                        valueProp: 'UserCategoryId',
                        labelProp: 'UserCategoryName',
                        placeholder: 'Select User Category',
                        onChange: function (a, b, events) {
                            onValidate(events.fc.$valid);
                        }
                    }
                },
                {
                    key: 'Level',
                    type: 'input',
                    templateOptions: {
                        type: 'number',
                        label: 'Level',
                        placeholder: 'Enter the Level of this user type',
                        required: true,
                        min: 1,
                        max: 100,
                        onChange: function (a, b, events) {
                            onValidate(events.fc.$valid);
                        }
                    }
                }];
            return fields;
        }

        function getUserTypeDisplayFields(onTruckAccessChanged) {
            var fields = [{
                type: 'radio',
                key: 'IsADUser',
                templateOptions: {
                    label: '',
                    labelProp: 'value',
                    valueProp: 'id',
                    theme: 'custom',
                    options: [
                        {
                            value: 'Internal User',
                            id: true
                        },
                        {
                            value: 'Exernal User',
                            id: false
                        }
                    ]
                }
            }, {
                id: 'CanEditOrganization',
                key: 'CanViewOrganization',
                type: 'toggle',
                templateOptions: {
                    label: 'Can View/Edit Organization',
                    activeText: 'YES',
                    inactiveText: 'NO'
                }
            }, {
                type: 'radio',
                key: 'TruckLimit',
                defaultValue: 0,
                templateOptions: {
                    label: 'Is Limited to the following trucks',
                    labelProp: 'value',
                    valueProp: 'id',
                    theme: 'custom',
                    options: [
                        {
                            value: 'Can view all Autocar trucks',
                            id: 0
                        },
                        {
                            value: 'Can view all Customer trucks',
                            id: 1
                        },
                        {
                            value: 'Can only view assigned trucks',
                            id: 2
                        }
                    ],
                    onChange: onTruckAccessChanged
                }
            }];
            return fields;
        }

        function getUserTypeCreateFields(onChange) {
            var fields = [{
                id: 'CanCreateUser',
                key: 'CanCreateUser',
                type: 'toggle',
                templateOptions: {
                    disabled: false,
                    label: 'User Type can Create User',
                    activeText: 'YES',
                    inactiveText: 'NO',
                    onChange: function (a, b, events) {
                        onChange(a, b);
                    }
                }
            },
            {
                id: 'CanCreateUserOutsideCategory',
                key: 'CanCreateOutsideCategory',
                type: 'toggle',
                templateOptions: {
                    disabled: true,
                    label: 'Can Create Outside of Category',
                    activeText: 'YES',
                    inactiveText: 'NO'
                }
            },
            {
                id: 'CanViewAllApplications',
                key: 'CanViewAllApplications',
                type: 'toggle',
                templateOptions: {
                    disabled: true,
                    label: 'Can View All Applications',
                    activeText: 'YES',
                    inactiveText: 'NO'
                }
            },
            {
                id: 'CanModifyApplicationRoles',
                key: 'CanModifyApplicationRoles',
                type: 'toggle',
                templateOptions: {
                    disabled: true,
                    label: 'Can Modify Application Roles',
                    activeText: 'YES',
                    inactiveText: 'NO'
                }
            }];
            return fields;
        }

        function getUserTypes(tableState) {
            var query = service.getODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject,
                    getTableConfig([]).columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'UserCategory/Level, Level', reverse: false
            };
            coreService.processODataSort(query, tableState.sort);

            return query
                .expand('UserCategory')
                .withInlineCount()
                .query()
                .$promise;
        }

        function getTableConfig(userCategories) {
            var tableConfig = {
                columns: [
                    {
                        id: 'UserCategoryLevel',
                        displayName: 'Category Level',
                        ODataKey: 'UserCategoryId',
                        type: 'dropDown',
                        DropDown: { parent: 'UserCategory', key: 'Level' },
                        options: dropDownUserCategoryLevels(userCategories)
                    },
                    {
                        id: 'UserCategoryId',
                        displayName: 'User Category',
                        ODataKey: 'UserCategoryId',
                        type: 'dropDown',
                        DropDown: { parent: 'UserCategory', key: 'UserCategoryName' },
                        options: dropDownUserCategoryTypes(userCategories)
                    },
                    {
                        id: 'UserTypeName',
                        displayName: 'User Type Name',
                        ODataKey: 'UserTypeName',
                        type: 'match'
                    },
                    {
                        id: 'Level',
                        displayName: 'Level',
                        ODataKey: 'Level',
                        type: 'match'
                    },
                    {
                        id: 'IsADUser',
                        displayName: 'Is Internal User',
                        ODataKey: 'IsADUser',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'true'
                            },
                            off: {
                                className: 'danger',
                                display: 'false'
                            }
                        }
                    },
                    {
                        id: 'CanCreateUser',
                        displayName: 'Can Create User',
                        ODataKey: 'CanCreateUser',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'true'
                            },
                            off: {
                                className: 'danger',
                                display: 'false'
                            }
                        }
                    },
                    {
                        id: 'CanModifyApplicationRoles',
                        displayName: 'Can Modify Application Roles',
                        ODataKey: 'CanModifyApplicationRoles',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'true'
                            },
                            off: {
                                className: 'danger',
                                display: 'false'
                            }
                        }
                    },
                    {
                        id: 'Active',
                        displayName: 'Is Active',
                        ODataKey: 'Active',
                        type: 'badge',
                        badge: {
                            on: {
                                className: 'success',
                                display: 'Active'
                            },
                            off: {
                                className: 'danger',
                                display: 'InActive'
                            }
                        }
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function dropDownUserCategoryTypes(userCategories) {
            return userCategories.map(function (category) {
                return {
                    value: category.UserCategoryId,
                    name: category.UserCategoryName
                };
            });
        }

        function dropDownUserCategoryLevels(userCategories) {
            return userCategories.map(function (category) {
                return {
                    value: category.UserCategoryId,
                    name: category.Level
                };
            });
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/settings/usertype/modal/usertype.modal.html',
                controllerAs: 'vm'
            };
        }

        function getDefaultUserType() {
            return {
                basic: {
                    UserTypeId: 0,
                    UserTypeName: '',
                    UserCategoryId: 1,
                    Level: 1
                },
                display: {
                    IsADUser: true,
                    CanViewOrganization: false,
                    TruckLimit: 2
                },
                create: {
                    CanCreateUser: false,
                    CanCreateOutsideCategory: false,
                    CanViewAllApplications: false,
                    CanModifyApplicationRoles: false
                },
                defaultApps: [],
                Active: true
            };
        }
    }
})();
